import * as React from 'react';
import { Layout } from 'react-admin';
import { Box } from '@mui/material';
import CustomAppBar from './CustomAppBar';
import CustomMenu from './CustomMenu';

const CustomLayout = (props) => (
    <Layout
        {...props}
        appBar={CustomAppBar}
        menu={CustomMenu}
        sx={{
            '& .RaLayout-content': {
                padding: '24px 32px',
                backgroundColor: '#f5f5f5',
            },
            '& .RaLayout-appFrame': {
                marginTop: '64px',
            },
            '& .MuiToolbar-root': {
                minHeight: '72px',
            },
            '& .notification-warning': {
                backgroundColor: '#fff3f4',
                color: '#E31837',
                padding: '12px 20px',
                borderRadius: '6px',
                marginBottom: '20px',
                fontSize: '0.95rem',
                border: '1px solid rgba(227, 24, 55, 0.2)',
            },
            '& .bulk-actions-toolbar': {
                backgroundColor: '#fff3f4',
                borderRadius: '6px',
                marginBottom: '20px',
            },
        }}
    >
        <Box
            component="main"
            sx={{
                flexGrow: 1,
                backgroundColor: '#f5f5f5',
                minHeight: 'calc(100vh - 72px)',
                '& .MuiPaper-root': {
                    marginBottom: 2,
                },
                '& .RaList-actions': {
                    marginTop: 1,
                },
            }}
        >
            {props.children}
        </Box>
    </Layout>
);

export default CustomLayout; 